const defconf = Object.assign({}, import.meta.env, window.__RUNTIME__ || {})

// Finder и Docviewer обращаются к API: адрес хоста без префикса иначе ведёт в SPA.
if (defconf.VITE_DOCPARSER_URL) {
  const docparserUrl = new URL(defconf.VITE_DOCPARSER_URL, window.location.origin)
  if (docparserUrl.pathname === '/') {
    docparserUrl.pathname = '/api/v1.0/'
  } else if (!docparserUrl.pathname.endsWith('/')) {
    docparserUrl.pathname += '/'
  }
  defconf.VITE_DOCPARSER_URL = docparserUrl.toString()
}

/** Корень Structure досье (ltms://…), scheme/бакет файлов. */
if (!defconf.VITE_DOSSIER_STORAGE) {
  defconf.VITE_DOSSIER_STORAGE = 'ltms'
}

export default defconf
